<template>
    <section class="base-header-sec base-header-laen  laen NotPrintableArea">
        <div class="base-header__top-line laen"></div>
        <div class="container-fluid">

            <div class=" container-lg  base-header__container ">
                <div class="inner ml-lg-5 d-lg-flex justify-content-between align-items-center">
                    <h2 class="base-header__title mob d-block d-lg-none">
                        РЕГИСТАР И ТЕКСТОВИ ВАЖЕЋИХ ПРОПИСА И ДРУГИХ АКАТА
                    </h2>
                    <ul class="nav ">
                        <li class="nav-item ">
                            <router-link class="nav-link  " to="/reg-overview">Садржај</router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link" to="/reg-latest" id="tab-svi-brojevi">Из најновијег броја</router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link  " to="/reg-search">Претрага</router-link>

                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " :to="{ path: '/reg-static', query: { page: 'help' ,code:'REG'}}">
                                Помоћ
                            </router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " :to="{ path: '/reg-static', query: { page: 'contact' ,code:'REG'}}">
                                Контакт
                            </router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link " :to="{ path: '/reg-static', query: { page: 'impresum' ,code:'REG'}}">
                                Импресум
                            </router-link>
                        </li>
                    </ul>
                    <h1 class="base-header__title d-none d-lg-block">
                        РЕГИСТАР И ТЕКСТОВИ ВАЖЕЋИХ ПРОПИСА И ДРУГИХ АКАТА
                    </h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "RegBaseHeaderSec"
    }
</script>

<style scoped>

</style>
